var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeleasistencia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 336 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f7f8f9;}.cls-4{fill:#e8e6e5;}.cls-5{fill:#fff;}.cls-6{fill:#b1afb0;}.cls-7{fill:#aecb39;}.cls-8{fill:#238ccc;}.cls-9{fill:#07599b;}.cls-10{fill:#06599b;}.cls-11{clip-path:url(#clippath-1);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.85,
    y: 41,
    width: 222,
    height: 222
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.91,201.95c0,27.59,22.36,49.95,49.95,49.95s49.95-22.36,49.95-49.95-22.36-49.95-49.95-49.95-49.95,22.36-49.95,49.95"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M207.49,251.9H118c-5.17,0-9.37-4.19-9.37-9.36V61.47c0-5.17,4.19-9.37,9.37-9.37h89.49c5.17,0,9.37,4.19,9.37,9.37V242.54c0,5.17-4.19,9.36-9.37,9.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.12,
    y: 77.08,
    width: 83.25,
    height: 137.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.21,225.59h9.06c2.25,0,4.08,1.83,4.08,4.08v9.07c0,2.25-1.83,4.08-4.08,4.08h-9.06c-2.25,0-4.08-1.83-4.08-4.08v-9.07c0-2.25,1.83-4.08,4.08-4.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "204.37 214.44 204.37 100.96 121.12 184.21 121.12 214.44 204.37 214.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M175.1,66.81h-24.72c-1.23,0-2.22-.99-2.22-2.22s.99-2.22,2.22-2.22h24.72c1.23,0,2.22,.99,2.22,2.22s-.99,2.22-2.22,2.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M266.81,201.95c0,27.59-22.36,49.95-49.95,49.95s-49.95-22.36-49.95-49.95,22.36-49.95,49.95-49.95,49.95,22.36,49.95,49.95"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.8,251.9h13.53c.48-1.73,.98-3.48,1.51-5.28l.62,5.28h42.77l.63-5.37c.54,1.83,1.05,3.62,1.54,5.37h13.53c-1.71-12.33-4.97-26.44-10.92-40.8h-52.31v.06c-5.92,14.34-9.18,28.42-10.89,40.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.67,186.38c0-11.23,9.11-20.34,20.34-20.34s20.34,9.11,20.34,20.34v5.01h-40.68v-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.84,206.04c10.26,0,18.57-8.31,18.57-18.57s-8.31-18.57-18.57-18.57-18.57,8.31-18.57,18.57,8.32,18.57,18.57,18.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.01,166.04c-10.66-.56-20.11,7.11-23.1,15.57,4,4.79,10.01,7.83,16.73,7.83,9.48,0,17.55-6.06,20.55-14.52-4-4.79-7.46-8.53-14.17-8.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 196.67,
    y: 184.38,
    width: 6.03,
    height: 7.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M211.41,227.25c0,4.12-3.34,7.47-7.47,7.47s-7.47-3.35-7.47-7.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 196.47,
    y: 220.55,
    width: 14.94,
    height: 6.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.78,236.25l.55-.31c-.89-1.6-1.36-3.44-1.36-5.35,0-5.49,3.89-9.95,8.67-9.95s8.67,4.46,8.67,9.95c0,1.9-.47,3.75-1.36,5.35l.55,.31c.94-1.69,1.43-3.64,1.43-5.65,0-5.83-4.17-10.58-9.3-10.58s-9.3,4.75-9.3,10.58c0,2.01,.5,3.96,1.44,5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.96,234.25c-.95,1.29-.67,3.1,.62,4.05,1.29,.95,3.1,.67,4.05-.62,.95-1.29,.67-3.1-.62-4.05-1.29-.95-3.1-.67-4.05,.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.32,234.25c.95,1.29,.67,3.1-.62,4.05-1.29,.95-3.1,.67-4.05-.62-.95-1.29-.67-3.1,.62-4.05,1.29-.95,3.1-.67,4.05,.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203,233.16c0,2.48,2.01,4.49,4.49,4.49s4.49-2.01,4.49-4.49-2.01-4.49-4.49-4.49-4.49,2.01-4.49,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.11,233.47c.08,0,.16-.03,.22-.09,.13-.12,.13-.32,.01-.45-.08-.08-7.55-8.21,.49-20.91,.09-.15,.05-.34-.1-.43-.15-.09-.34-.05-.43,.1-2.39,3.78-4.92,9.59-3.37,15.8,.93,3.73,2.87,5.8,2.96,5.89,.06,.07,.14,.1,.23,.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "233.66 222.49 234.21 222.19 228.64 211.76 223.07 222.19 223.63 222.49 228.64 213.1 233.66 222.49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleasistencia);
export default __webpack_public_path__ + "static/media/Teleasistencia.57229a77afd3557cbc225eede4b254f6.svg";
export { ForwardRef as ReactComponent };